import React from "react";
import { Notice, panelStyle, SectionTitle, StatCard, subtlePanelStyle } from "./GangsheetUI";

type Props = {
  usedLengthIn: number;
  remainingLengthIn: number;
  itemsCount: number;
  sheetLengthIn: number;
  hasOverlap: boolean;
  hasBoundsIssue: boolean;
  hasLowDpi: boolean;
};

export default function GangsheetStats({
  usedLengthIn,
  remainingLengthIn,
  itemsCount,
  sheetLengthIn,
  hasOverlap,
  hasBoundsIssue,
  hasLowDpi,
}: Props) {
  return (
    <div style={{ ...panelStyle, padding: 14, display: "grid", gap: 14 }}>
      <SectionTitle
        title="Sheet Summary"
        subtitle="Usage, quality, and export status."
      />

      <div style={{ ...subtlePanelStyle, padding: 14, display: "grid", gap: 12 }}>
        <div style={{ display: "grid", gap: 10, gridTemplateColumns: "1fr 1fr" }}>
          <StatCard label="Used Length" value={`${usedLengthIn.toFixed(2)}"`} />
          <StatCard label="Remaining" value={`${remainingLengthIn.toFixed(2)}"`} />
          <StatCard label="Artwork Count" value={`${itemsCount}`} />
          <StatCard label="Max Length" value={`${sheetLengthIn}"`} />
        </div>

        <Notice
          active={hasOverlap}
          tone="red"
          text={
            hasOverlap
              ? "Overlap detected. Move artwork apart before exporting."
              : "No artwork overlap detected."
          }
        />
        <Notice
          active={hasBoundsIssue}
          tone="red"
          text={
            hasBoundsIssue
              ? "Some artwork is outside the gangsheet area."
              : "All artwork is inside the sheet bounds."
          }
        />
        <Notice
          active={hasLowDpi}
          tone={hasLowDpi ? "yellow" : "green"}
          text={
            hasLowDpi
              ? "One or more images are below 300 DPI at placed size."
              : "All placed images are at 300 DPI or better."
          }
        />
      </div>
    </div>
  );
}